import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import TagsInput from 'react-tagsinput';
import styles from '../fields.module.scss';

class String extends Component {
  constructor(props) {
    super(props);
    const { isRequired, answer, updateFieldErrors, default_text, fieldId } = this.props;
    if (isRequired && !answer) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
    if (default_text && fieldId && !answer) {
      this.handleAnswerChanged(default_text, fieldId);
    }
  }

  isInvalidEmail = (email) => {
  const { validators } = this.props;
  if (!validators?.[0]?.multiple_email) return false;

  const regexPattern = validators[0]?.value;
  if (!regexPattern) return false;

  const regex = new RegExp(regexPattern);
  return !regex.test(email.trim());
};

  handleDependencyFields = () => {
    const { formEntryFields, fieldId, handleValueChange, handleFieldErrorChanged } = this.props;
    if (formEntryFields?.length > 0) {
      formEntryFields.forEach((field) => {
        if (field?.type === 'number'
          && field?.settings?.form_count
          && Object.values(field?.settings?.count_map_fields || {})?.filter(f => f?.id === fieldId)?.length > 0
        ) {
          handleValueChange(undefined, field?.id);
          handleFieldErrorChanged(field?.id, true);
        }
      });
    }
  }

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors, fields, fromMultiGrid, multiFields
    } = this.props;
    const field_type = (fromMultiGrid && multiFields?.[fieldId])
    ? multiFields?.[fieldId]?.validator
    : fields?.find(obj => obj.id === fieldId)?.validators?.[0];
    if (fromMultiGrid) {
      const fieldType = multiFields[fieldId];
      if (Object.keys(fieldType || {})?.length > 0
        && Object.keys(fieldType?.validator || {})?.length > 0
        && fieldType.validator?.type === 'charValidation') {
        const caseType = fieldType.validator?.name;
        let inputValue = value;
        if (caseType === 'Capital Letters') {
          inputValue = inputValue.toUpperCase();
        } else if (caseType === 'Small Letters') {
          inputValue = inputValue.toLowerCase();
        }
        handleValueChange(inputValue, fieldId);
      } else {
        handleValueChange(value, fieldId);
      }
    } else {
      const fieldType = Array.isArray(fields) && fields?.find(obj => obj.id === fieldId);
      if (Object.keys(fieldType || {})?.length > 0 && fieldType.validators?.length > 0 && fieldType.validators[0]?.type === 'charValidation') {
        const caseType = fieldType.validators[0]?.label;
        let charLimit = Number(fieldType.validators[0]?.charValue) || null;
        let inputValue = value;
        if (caseType === 'Capital Letters') {
          inputValue = inputValue.toUpperCase();
        } else if (caseType === 'Small Letters') {
          inputValue = inputValue.toLowerCase();
        } else if (caseType === 'Alphanumeric') {
          inputValue = inputValue
            .split('')
            .filter(char => /[A-Za-z0-9]/.test(char))
            .join('');
        }
        // Enforce character limit
        if (charLimit) {
          inputValue = inputValue.slice(0, charLimit);
        }
        handleValueChange(inputValue, fieldId);
      } else {
        handleValueChange(value, fieldId);
      }
    }
    let updatedErrors = [];
    const max_min = field_type || {};

    if (value === '' || value === undefined || value.trim() === '') {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    } else if (max_min?.type === 'min_max') {
      const length = value?.length ?? 0;
      const min = max_min?.minValue && +max_min?.minValue;
      const max = max_min?.maxValue && +max_min?.maxValue;

      if (min && length < min) {
        updatedErrors = [
          ...updatedErrors,
          {
            id: 'pulpoforms.errors.limit.minlength',
            values: { count: min }
          }
        ];
        handleFieldErrorChanged(fieldId, true);
      } else if (max && length > max) {
        updatedErrors = [
          ...updatedErrors,
          {
            id: 'pulpoforms.errors.limit.maxlength',
            values: { count: max }
          }
        ];
        handleFieldErrorChanged(fieldId, true);
      } else {
        handleFieldErrorChanged(fieldId, false);
      }
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    this.handleDependencyFields();
    updateFieldErrors(updatedErrors);
  }

  renderEmailTag = (props) => {
  const { tag, key, onRemove, classNameRemove, getTagDisplayValue } = props;
  const isInvalid = this.isInvalidEmail(tag.trim());
  return (
    <span
      key={key}
      className={`react-tagsinput-tag ${isInvalid ? 'invalidTag' : ''}`}
      style={{
        paddingBottom: '5px'
      }}
    >
      {getTagDisplayValue(tag)}
      <button className={classNameRemove} onClick={() => onRemove(key)} aria-label={`Remove ${tag}`} style={{
          border: 'none',
          background: 'transparent',
          position: 'relative',
          outline: 'none',
          top: '30%',
          transform: 'translateY(-30%)'
        }} />
    </span>
  );
};


  render() {
    const { widget: { type: widget }, fieldId, answer, rows, disabled, placeHolder, customStyles, validators } = this.props;

    let fieldWidget;
    if (widget === 'charfield') {
      fieldWidget = (
         validators?.[0]?.multiple_email
         ?<>
            <TagsInput
              value={answer?.length ? (answer)?.split(',') : []}
              onlyUnique
              inputProps={{ placeholder: 'name@email.com' }}
              addKeys={[9, 13, 188]}
               renderTag={this.renderEmailTag}
               onChange={(tags) => {
               const cleaned = tags.map(t => t.trim()).filter(t => t !== '');
               this.handleAnswerChanged(cleaned.join(','), fieldId);
               }}
              className={styles.tagsinput}
            />
          </>
          : <input
          type="text"
          name={`string-field-${fieldId}`}
          value={answer}
          disabled={disabled}
          onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
          className={`pulpo-charfield ${customStyles || ''}`}
          style={{ height: '37px' }}
          placeholder={placeHolder||''}
        />
      );
    } else if (widget === 'richtextfield') {
      fieldWidget = (
        <ReactQuill
          value={answer}
          name={`string-field-${fieldId}`}
          onChange={e => this.handleAnswerChanged(e, fieldId)}
          modules={{
            toolbar: {
              container: [
                [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                [{ size: [] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link'],
                ['link', 'image'],
                ['clean'],
                ['code-block'],
                [{ color: [] }, { background: [] }]
              ]
            }
          }}
          className={styles.rteFullInput}
        />
      );
    } else {
      fieldWidget = (
        <textarea
          className="pulpo-textarea"
          name={`string-field-${fieldId}`}
          style={{ height: 'initial' }}
          defaultValue={answer}
          disabled={disabled}
          onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
          rows={rows}
        />
      );
    }
    return fieldWidget;
  }
}


String.defaultProps = {
  widget: { type: 'charfield' },
  answer: '',
  rows: 5
};

String.propTypes = {
  widget: PropTypes.shape({ type: PropTypes.string }),
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  rows: PropTypes.number
};

export default String;
